import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import BasePage from 'apps/auth/components/utils/BasePage';
import { CARD_VERIFICATION_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { resolveArguments } from 'apps/auth/helpers/utils';

import CancelPopup from './CancelPopup';

const ConfirmPreview = (props) => {
    useEffect(() => {
        amplitude.getInstance().logEvent(CARD_VERIFICATION_SCREEN_SHOWN);
    }, []);

    const popupRef = useRef(null);
    const arg = [props.confirm_amount?.amountTo, props.confirm_amount?.recipientInfo, props.confirm_amount?.accountFrom];
    if (!props.is_amount) {
        arg.push(props.confirm_amount?.fixAmount);
    }

    return (
        <BaseLayout>
            <InfoPage
                iconName="zap-80"
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={props.headerTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={resolveArguments(props.explanatory_text, arg)} />}
                primaryButtonCaption={props.verifyCard}
                primaryButtonType="link"
                primaryButtonLink={`/auth/card/confirm/${props.sms_confirm.objectId}`}
                topButtonCaption={props.cancelButton}
                topButtonOnClick={(e) => {
                    e.preventDefault();
                    popupRef.current?.open(<CancelPopup popupRef={popupRef} />);
                }}
                topButtonType="button"
            />
            <PopupNew ref={popupRef} />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        headerTitle: state.messages.pageMessages.headerTitle,
        verifyCard: state.messages.pageMessages.verifyCard,
        cancelButton: state.messages.pageMessages.cancelButton,
        explanatory_text: state.extra.explanatory_text,
        is_amount: state.extra.is_amount,
        confirm_amount: state.extra.confirm_amount,
        sms_confirm: state.extra.sms_confirm,
    };
};
export default connect(mapStateToProps, null)(BasePage(ConfirmPreview));
